import { Row, Box, BoxProps, TextWithTooltip, HtImage } from "@hightouch/htui";
import { HightouchLogo } from "src/ui/icons";
import { Logo as MobileLogo } from "src/ui/brand";
import { useUser } from "src/contexts/user-context";
import { RouterLink } from "src/router";

export function SmallLogo(props: BoxProps) {
  const { user } = useUser();

  return (
    <Box {...props}>
      {user?.organization?.logo_url ? (
        <OrganizationLogo />
      ) : (
        <MobileLogo
          size="24px"
          theme="dark"
          fill="var(--chakra-colors-gray-600)"
        />
      )}
    </Box>
  );
}

export function FullLogo() {
  const { user } = useUser();
  const hasOrgLogo = user?.organization?.logo_url;

  return (
    <Row
      as={RouterLink}
      aria-label="Home"
      to="/"
      align="center"
      justify={hasOrgLogo ? "center" : "flex-start"}
      borderRadius="lg"
      flex={1}
      minW={0}
      overflow="hidden"
      _focusVisible={{
        boxShadow: "outline",
      }}
    >
      {hasOrgLogo ? (
        <OrganizationLogoAndName />
      ) : (
        <HightouchLogo width="123px" height="24px" color="gray.600" />
      )}
    </Row>
  );
}

export function OrganizationLogo() {
  const { user } = useUser();

  if (!user?.organization?.logo_url) {
    return null;
  }

  return (
    <Row
      align="center"
      boxSize={10}
      borderRadius="2xl"
      borderWidth="hairline"
      borderStyle="solid"
      borderColor="base.border"
      boxShadow="buttonShadow"
      justify="center"
      flexShrink={0}
      overflow="hidden"
      pos="relative"
    >
      <HtImage
        src={`${user.organization.logo_url}?w=120`}
        alt={user.organization.name}
        width="40px"
        height="40px"
        objectFit="contain"
        objectPosition="center"
      />
    </Row>
  );
}

function OrganizationLogoAndName() {
  const { user } = useUser();

  return (
    <Row align="center" gap={2} flex={1} minW={0} overflow="hidden">
      <OrganizationLogo />
      {user?.organization?.name && (
        <TextWithTooltip
          message={user.organization.name}
          sx={{
            color: "text.primary",
            fontWeight: "semibold",
            fontSize: "md",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            minW: 0,
          }}
        >
          {user.organization.name}
        </TextWithTooltip>
      )}
    </Row>
  );
}
